// 静态路由
const isSpecialDomain = window.location.hostname === 'luckysushi.dk'
const isMobile=navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
const getHomeComponent=()=> {
    if(isSpecialDomain){
        if(isMobile){
            return  import('../views/mobile/Index.vue') 
        }
        else{
            return import('../views/pages/Index.vue')
        }
    }
    else{
        return import('../views/Index.vue');
    }
  }

export const staticRouter = [
      {
        path:'/',
        component:() => 
            getHomeComponent(),
        meta: { title: ''}
    },
    {
        path:'/:id',
        component:() => import('../views/Index.vue'),
        meta: { title: ''}
    },
    {
        path:'/page/index',
        component:() => import('../views/pages/Index.vue'),
         meta: { 
                h1Title: 'Lucky Sushi – Sushi Takeaway & Delivery i Køge, Greve og Slagelse' 
            }
    },
    {
        path:'/coupon/:id',
        component:() => import('../views/coupon/Index.vue'),
        meta: { title: 'Coupon'}
    },
    {
        path:'/takeaway/:id',
        component:() => import('../views/pages/IndexView.vue'),
        meta: { title: ''}
    },
    {
        path:'/takeaway/paymentSuccess/:id',
        component:() => import('../views/results/PaymentSuccess.vue'),
        meta: { title: ''}
    },
    {
        path:'/takeaway/paymentFailed/:id',
        component:() => import('../views/results/PaymentFailed.vue'),
        meta: { title: ''}
    },
    {
        path:'/takeaway/cartList/:id',
        component:() => import('../views/pages/CartListView.vue'),
        meta: { title: 'Delivery and time'}
    },
    {
        path:'/takeaway/buyerInfo/:id',
        component:() => import('../views/pages/BuyerInfoView.vue'),
        meta: { title: 'Delivery and time'}
    },
    {
        path:'/contact/:tempId/:customId/:id',
        component:() => import('../views/pages/BookingTable.vue'),
        meta: { title: ''}
    },
    {
        path:'/info/:tempId/:customId/:id',
        component:() => import('../views/pages/CustomView.vue'),
        meta: { title: ''}
    },
    {
        path:'/allyoucaneat/:tempId/:customId/:id',
        component:() => import('../views/pages/AllYouCanEat.vue'),
        meta: { title: ''}
    },
    {
        path:'/register/:tempId/:id',
        component:() => import('../views/pages/Register.vue'),
        meta: { title: ''}
    },
    {
        path:'/login/:tempId/:id',
        component:() => import('../views/pages/Login.vue'),
        meta: { title: ''}
    },
    {
        path:'/userCenter/:tempId/:id',
        component:() => import('../views/pages/UserCenter.vue'),
        meta: { title: ''}
    },
    //mobile
    {
        path:'/mobile/index',
        component:() => import('../views/mobile/Index.vue'),
        meta: { 
            h1Title: 'Lucky Sushi – Sushi Takeaway & Delivery i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/login/:id',
        component:() => import('../views/mobile/Login.vue'),
         meta: { 
            h1Title: 'Lucky Sushi – Sushi Takeaway & Delivery i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/userCenter/:id',
        component:() => import('../views/mobile/UserCenter.vue'),
        meta: { 
            h1Title: 'Lucky Sushi – Sushi Takeaway & Delivery i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/userInfo/:id',
        component:() => import('../views/mobile/UserInfo.vue'),
         meta: { 
            h1Title: 'Lucky Sushi – Sushi Takeaway & Delivery i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/forget/:id',
        component:() => import('../views/mobile/Forget.vue'),
         meta: { 
            h1Title: 'Lucky Sushi – Sushi Takeaway & Delivery i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/myOrder/:id',
        component:() => import('../views/mobile/MyOder.vue'),
         meta: { 
            h1Title: 'Lucky Sushi – Sushi Takeaway & Delivery i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/takeaway/:id',
        component:() => import('../views/mobile/IndexView.vue'),
         meta: { 
            h1Title: 'Lucky Sushi – Sushi Takeaway & Delivery i Køge, Greve og Slagelse' 
        }
    },
    {
        name:'mobileFoodList',
        path:'/mobile/takeaway/foodlist/:id',
        component:() => import('../views/mobile/FoodListView.vue'),
         meta: { 
            h1Title: 'Lucky Sushi – Sushi Takeaway & Delivery i Køge, Greve og Slagelse' 
        }
    },
   
    {
        path:'/mobile/takeaway/cartlist/:id',
        component:() => import('../views/mobile/CartListView.vue'),
        meta: { 
            h1Title: 'Lucky Sushi – Sushi Takeaway & Delivery i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/takeaway/time/:id',
        component:() => import('../views/mobile/TimeView.vue'),
        meta: { 
            h1Title: 'Lucky Sushi – Sushi Takeaway & Delivery i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/takeaway/buyerInfo/:id',
        component:() => import('../views/mobile/BuyerInfoView.vue'),
         meta: { 
            h1Title: 'Lucky Sushi – Sushi Takeaway & Delivery i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/takeaway/success/:id',
        component:() => import('../views/mobile/OrderSuccessView.vue'),
         meta: { 
            h1Title: 'Lucky Sushi – Sushi Takeaway & Delivery i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/takeaway/detail/:id',
        component:() => import('../views/mobile/OrderDetailsView.vue'),
       meta: { 
            h1Title: 'Lucky Sushi – Sushi Takeaway & Delivery i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/contact/:tempId/:customId/:id',
        component:() => import('../views/mobile/BookingTable.vue'),
        meta: { 
            h1Title: 'Lucky Sushi – Sushi Takeaway & Delivery i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/allyoucaneat/:tempId/:customId/:id',
        component:() => import('../views/mobile/AllYouCanEat.vue'),
         meta: { 
            h1Title: 'Lucky Sushi – Sushi Takeaway & Delivery i Køge, Greve og Slagelse' 
        }
    },
    // {
    //     path:'*',
    //     component:() => import('../views/staticRoutes/static1.vue'),
    //     meta: { title: '错误404',hidden:true}
    // }
      //demo 
      {
        path:'/mobile/takeaway/:id/:foodTypeId',
        component:() => import('../views/mobile/IndexView.vue'),
         meta: { 
            h1Title: 'Lucky Sushi – Sushi Takeaway & Delivery i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/takeaway/foodlist/:id/:foodTypeId/:foodTypeName/:showType',
        component:() => import('../views/mobile/FoodListView.vue'),
         meta: { 
            h1Title: 'Lucky Sushi – Sushi Takeaway & Delivery i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/takeaway/time/:id/:deliveryTip',
        component:() => import('../views/mobile/TimeView.vue'),
         meta: { 
            h1Title: 'Lucky Sushi – Sushi Takeaway & Delivery i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/takeaway/buyerInfo/:id/:deliveryTip',
        component:() => import('../views/mobile/BuyerInfoView.vue'),
         meta: { 
            h1Title: 'Lucky Sushi – Sushi Takeaway & Delivery i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/mobile/info/:tempId/:customId/:id',
        component:() => import('../views/mobile/CustomView.vue'),
         meta: { 
            h1Title: 'Lucky Sushi – Sushi Takeaway & Delivery i Køge, Greve og Slagelse' 
        }
    },
    {
        path:'/b/takeaway/:id',
        component:() => import('../views/takeaway02/IndexView.vue'),
        meta: { title: 'Takeaway'}
    },
    {
        path:'/b/checkout/:id',
        component:() => import('../views/takeaway02/Checkout.vue'),
        meta: { title: 'Checkout',keepAlive: false }
    },
    {
        path:'/b/order/:id',
        component:() => import('../views/takeaway02/OrderDetial.vue'),
        meta: { title: 'My order'}
    },
    {
        path:'/b/show/:activeIndex/:id',
        component:() => import('../views/takeaway02/Custom.vue'),
        meta: { title: 'Info'}
    },
    {
        path:'/b/cartList/:id',
        component:() => import('../views/takeaway02/CartList.vue'),
        meta: { title: 'Cart list'}
    },
    {
        path:'/booking/:id',
        component:() => import('../views/booking/Index.vue'),
        meta: { title: 'Booking'}
    },
     {
        path:'/e-invoice/:type/:id',
        component:() => import('../views/bill/Index.vue'),
        meta: { title: 'E-invoice'}
    },
      {
        path:'/pre-invoice/:type/:id',
        component:() => import('../views/bill/Preview.vue'),
        meta: { title: 'E-invoice'}
    },
      {
        path:'/booking/edit/:id',
        component:() => import('../views/booking/EditBookingTable.vue'),
        meta: { title: 'Edit booking'}
    },
]
// 在方法或计算属性中
